import { httpClient } from "@/lib/httpClient";

export interface PendingApproval {
  versionId: string;
  pageId: string;
  pageSlug: string;
  sectionSlug: string;
  sectionTitle: string;
  title: string;
  versionNo: number;
  isNewPage: boolean;
  changeSummary: string | null;
  authorName: string | null;
  submittedAt: string | null;
  approvedSoFar: number;
  required: number;
}

export interface ReviewView {
  versionId: string;
  title: string;
  html: string;
  proposedText: string;
  publishedText: string | null;
  publishedTitle: string | null;
  isNewPage: boolean;
  changeSummary: string | null;
  authorName: string | null;
  submittedAt: string | null;
}

export const approvalsService = {
  listPending: () => httpClient.get<{ pending: PendingApproval[] }>("/api/cms/approvals"),

  getReview: (versionId: string) =>
    httpClient.get<ReviewView>(`/api/cms/versions/${versionId}/review`),

  approve: (versionId: string, csrfToken: string) =>
    httpClient.post<{ outcome: "published" | "in_review" }>(
      `/api/cms/versions/${versionId}/approve`,
      { json: {}, headers: { "x-csrf-token": csrfToken } }
    ),

  reject: (versionId: string, note: string, csrfToken: string) =>
    httpClient.post<{ outcome: "draft" }>(`/api/cms/versions/${versionId}/reject`, {
      json: { note },
      headers: { "x-csrf-token": csrfToken },
    }),
};
